export const validateNumber = (input: string) => {
    return !isNaN(parseInt(input));
}